module.exports = __webpack_public_path__ + "img/up-arrow.0c073e61.svg";